
import { Tag } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Product } from './ProductCard';

interface CategoryCardProps {
  category: string;
  products: Product[];
}

export function CategoryCard({ category, products }: CategoryCardProps) {
  const categoryProducts = products.filter(p => p.category === category);
  
  return (
    <Card key={category}>
      <CardHeader className="p-4">
        <CardTitle className="text-lg flex items-center">
          <Tag className="h-4 w-4 mr-2" />
          {category}
        </CardTitle>
        <CardDescription>
          {categoryProducts.length} product(s)
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <ul className="text-sm space-y-1">
          {categoryProducts.slice(0, 5).map(product => (
            <li key={`${product.source}-${product.id}`} className="truncate">
              {product.name}
              {product.source === 'recommendations' && (
                <span className="text-xs text-muted-foreground ml-1">(recommendation)</span>
              )}
            </li>
          ))}
          {categoryProducts.length > 5 && (
            <li className="text-muted-foreground">
              +{categoryProducts.length - 5} more
            </li>
          )}
        </ul>
      </CardContent>
    </Card>
  );
}
